<template>
  <v-dialog :value="open" @click:outside="closeDialog()" scrollable max-width="500">
    <ValidationObserver ref="specialtiesFormObs" v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ EditMode ? "Actualizar" : "Crear" }} Especialidad
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 570px">
            <v-form>
              <v-row dense>
                <!-- Nombre -->
                <v-col cols="12">
                  <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Nombre"
                      name="name"
                      type="text"
                      color="blue-grey"
                      v-model="formData.name"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Descripcion -->
                <v-col cols="12">
                  <ValidationProvider name="Descripcion" rules="required" v-slot="{ errors }">
                    <v-textarea
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Descripcion"
                      name="name"
                      type="text"
                      color="blue-grey"
                      v-model="formData.description"
                      :error-messages="errors"
                    >
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="closeDialog()">Cancelar</v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click.stop="handleSubmit(submitForm)"
            >
              {{ EditMode ? "Guardar" : "Crear" }}
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: { vuescroll },
  props: {
    open: {
      type: Boolean,
    },
    editData: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      formData: { name: "", description: "" },
    };
  },

  computed: {
    EditMode() {
      return !!this.editData;
    },
    User() {
      return this.$store.getters["passport/CURRENT_USER"];
    },
  },

  watch: {
    open(val) {
      if (val) {
        if (this.editData) {
          const { name, description } = this.editData;
          this.formData = { name, description };
        }
      } else {
        this.formData = {
          name: "",
          description: "",
        };
      }
    },
  },

  methods: {
    closeDialog(item) {
      this.$emit("dialog:close", item);
      this.$refs.specialtiesFormObs.reset();
    },

    async submitForm() {
      this.isLoading = true;
      let savedData;
      try {
        if (this.EditMode) {
          const { id } = this.editData;
          const { data } = await PbxHttpClient.put(`/module_appointment/specialties/${id}`, this.formData);
          savedData = data;
          this.$snotify.success("Especialidad actualizada con exito", "¡Hecho!");
        } else {
          const { data } = await PbxHttpClient.post("/module_appointment/specialties", this.formData);
          savedData = data;
          this.$snotify.success("Especialidad creada con exito", "¡Hecho!");
        }
        this.closeDialog(savedData);
      } catch (err) {
        this.$snotify.error("Hubo un error guardando la Especialidad", "¡Error!");
        // console.log("Error in post:", err);
      }
      this.isLoading = false;
    },
  },
};
</script>
